import React from 'react';
import { Loading } from '@components/common';
import { AccountTable } from './components';
import ApplicationContext from './context';
import { PageWrapper } from './styled';
import useFetchApp from './hooks/useFetchApps';
import { Spin } from 'antd';

const Applications = () => {
  const { isLoading, isFetching, profiles } = useFetchApp();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ApplicationContext.Provider
      value={{
        theme: 'light',
      }}
    >
      <PageWrapper>
        <AccountTable profiles={profiles} isFetching={isFetching} />
      </PageWrapper>
    </ApplicationContext.Provider>
  );
};

export default Applications;
